/* ELSKA by LINTEL PDP: two option groups -> variant id, gallery jump per metal, qty, midnight timer, sticky bar, cart drawer after add */
(function () {
  var vj = document.querySelector('[data-dn-variants]');
  var variants = vj ? JSON.parse(vj.textContent) : [];
  var form = document.querySelector('form[data-dn-add]');
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-dn-opt]'));
  function jump(metal) {
    var key = /Yellow/.test(metal) ? 'Yellow Gold' : 'White Gold';
    var th = document.querySelector('.oak-gal__thumbs button[data-dn-col="' + key + '"]');
    if (th) th.click();
  }
  function current() { return groups.map(function (g) { var b = g.querySelector('.is-on'); return b ? b.getAttribute('data-value') : null; }); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function update(fromClick, grp) {
    var sel = current();
    var v = variants.filter(function (x) { return x.options.every(function (o, i) { return norm(o) === norm(sel[i]); }); })[0];
    if (!v || !form) return;
    var inp = form.querySelector('input[name=id]');
    inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true }));
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    if (fromClick && grp === 0) jump(sel[0]);
  }
  groups.forEach(function (g, gi) {
    g.querySelectorAll('.dn-opt__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        g.querySelectorAll('.dn-opt__btn').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        update(true, gi);
      });
    });
  });
  var m = location.search.match(/[?&]variant=(\d+)/);
  if (m) {
    var hit = variants.filter(function (x) { return String(x.id) === m[1]; })[0];
    if (hit) {
      groups.forEach(function (g, i) { g.querySelectorAll('.dn-opt__btn').forEach(function (b) { b.classList.toggle('is-on', norm(b.getAttribute('data-value')) === norm(hit.options[i])); }); });
      update(false); setTimeout(function () { jump(hit.options[0]); }, 300);
    }
  }
  document.querySelectorAll('[data-dn-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = form.querySelector('input[name=quantity]');
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-dn-step'), 10));
    });
  });
  var t = document.querySelector('[data-dn-timer]');
  function tick() {
    var n = new Date(), e = new Date(n); e.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((e - n) / 1000));
    var p = function (x) { return (x < 10 ? '0' : '') + x; };
    if (t) t.textContent = p(Math.floor(s / 3600)) + ':' + p(Math.floor(s % 3600 / 60)) + ':' + p(s % 60);
  }
  tick(); setInterval(tick, 1000);
  var sticky = document.querySelector('[data-dn-sticky]'), buy = document.getElementById('dn-buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(buy);
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; if (window.DN) window.DN.openCart(); })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the DN brand cart drawer ===== */
(function () {
  if (window.__dn_atc) return; window.__dn_atc = 1;
  function open() { if (window.DN && window.DN.openCart) return window.DN.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
